import { render, staticRenderFns } from "./PortraitLevel2.vue?vue&type=template&id=66fdc470&scoped=true"
import script from "./PortraitLevel2.vue?vue&type=script&lang=js"
export * from "./PortraitLevel2.vue?vue&type=script&lang=js"
import style0 from "./PortraitLevel2.vue?vue&type=style&index=0&id=66fdc470&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fdc470",
  null
  
)

export default component.exports